const updateMemberCreditsValidityToast = (state = null, action) => {
  if (action.type === "SET_UPDATE_MEMBER_CREDITS_VALIDITY_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_UPDATE_MEMBER_CREDITS_VALIDITY_TOAST": {
  //     return action.payload;
  //   }
  
  //   default: {
  //     return state;
  //   }
  // }
};

export default updateMemberCreditsValidityToast;
